// extracted by mini-css-extract-plugin
module.exports = {"multiSelectCrumbs":"vA-z"};